<template>
  <div class="page">
    <!-- <header class="topbar">
      <h1 class="brand">Xmi Number One</h1>
      <div class="sub">Minigame Center — Play free games</div>
    </header> -->

    <main class="container">
      <router-view />
    </main>

    <!-- <footer class="footer">
      <div class="foot" css-foot="">
        <div class="footStyle" css-foot="">
          <div class="div1" css-foot="">
            <div class="linkText" style="height: 10px; line-height: 10px" css-foot="">
              <a css-foot="" href="https://about.minigame.vip"> About </a>
              <a href="/privacy" css-foot=""> Privacy </a>
              <a href="/terms" css-foot=""> Terms </a>
              <div id="selectLanguage" css-foot="">English(US)</div>
            </div>
            <div class="logoStyle" css-foot="">
              <p css-foot="">
                © 2025
                <a href="https://autodeploy1maylikead.minigame.com/" css-foot=""><span
                    css-foot="">minigame.com</span></a>
              </p>
              <p css-foot="" style="font-size: 12px">
                All game content on this site is provided by
                <a href="https://business.minigame.com/" target="_blank" css-foot=""><span
                    css-foot="">minigame.com</span></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'App',

    mounted() {
      window.dataLayer = window.dataLayer || [];

    // ✅ 页面停留 10 秒上报
    setTimeout(() => {
      window.dataLayer.push({
        event: "page_stay_10s",
        page_name: "Home"
    
      });
    }, 10000);
  },
}


</script>

<style>

  
:root {
    --foot-margin-top-height: 22px;
}

.foot[css-foot] {
    width: 100%;
    font-size: 18px;
}

.footStyle[css-foot] {
    --foot-box-shadow: 0 15px 64px 16px rgba(0, 0, 0, .15);
    position: relative;
    margin-top: 22px;
    margin-top: var(--foot-margin-top-height);
    padding-top: 40px;
    padding-bottom: 80px;
    width: 100%;
    box-shadow: var(--foot-box-shadow);
    text-align: center;
    font-family: Helvetica;
    font-weight: 400;
    color: #747474 !important
}

.div1[css-foot] {
    background-color: rgba(228, 161, 15, 0)
}

.logoStyle[css-foot] {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-height: 50px
}

.logoStyle>p[css-foot] {
    margin-top: 6px !important;
    margin-top: 0;
    margin-bottom: 0
}

.logoStyle a[css-foot]:-webkit-any-link {
    margin-top: 10px;
    cursor: pointer;
    text-decoration: none
}

.logoStyle a>span[css-foot] {
    font-family: Helvetica;
    font-weight: 400;
    color: #747474 !important
}

.linkText[css-foot] {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #747474 !important
}

.linkText>a[css-foot]:-webkit-any-link {
    margin-right: 15px;
    cursor: pointer;
    text-decoration: none;
    color: #747474 !important
}

#selectLanguage>img[css-foot] {
    margin: 0 0 2px 6px
}

.openSelectStyle[css-foot] {
    position: absolute;
    right: calc(50% - 150px);
    bottom: 90%;
    width: 200px
}

.footStyle[css-foot] {
    padding-top: 70px;
}

.footStyle[css-foot]::before {
    position: absolute;
    top: 23px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url(../public/assets/static/images/logo.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 24px;
    width: 121px;
    display: block;
    content: "";
}
</style>
